<template>
    <base-page title="终端异常" icon="ios-bug">
        <Row  slot="extra" type="flex" justify="end">
            <Col>
                <Button type="primary" @click="loadData(page.current)">刷新</Button>
            </Col>
            <Col class="margin-left-5">
                <res-view :keyName="'fun_exception_delete'">
                    <Button type="primary" @click="onDelete">删除</Button>
                </res-view>
            </Col>
            <Col class="margin-left-5">
                <res-view :keyName="'fun_exception_empty'">
                    <Button type="error" @click="onEmpty">清空</Button>
                </res-view>
            </Col>
        </Row>
        <template>
            <Row class="margin-top-10">
                <Table stripe border
                       ref="table"
                       :columns="columns"
                       :data="data"
                       :loading="loading"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="center">
                <Col>
                    <Page :current="page.current"
                          :page-size="page.size"
                          :total="page.total"
                          show-elevator
                          @on-change="loadData($event)"
                          size="small">
                    </Page>
                </Col>
            </Row>
        </template>
    </base-page>
</template>

<script>
    import expandRow from './component/exception-expand';
    import util from '@/libs/util';
    import ResView from '../my-components/res-view';
    import BasePage from "../my-components/base-page";

    export default {
        name: "page_terminal_exception",
        components: {BasePage, ResView, expandRow},
        data() {
            let that = this;
            return {
                loading: false,
                search: '',
                otherField: [],
                identityList: [
                    {
                        label: '一体机终端',
                        value: 0
                    },
                    {
                        label: '人脸识别终端',
                        value: 2
                    },
                ],
                page: {
                    current: 1,
                    size: 10,
                    total: 0,
                    sortKey: 'id',
                    sortMethod: 'desc',
                    keyword: ''
                },
                columns: [
                    {
                        type: 'selection',
                        align: 'center',
                        width: 60,
                    },
                    {
                        title: 'ID',
                        key: 'id',
                        align: 'center',
                        width: 100
                    },
                    {
                        title: '终端身份',
                        align: 'center',
                        width: 120,
                        key: 'identifier',
                        render: (h, params) => {
                            for (let type of this.identityList) {
                                if (type.value == params.row.identifier) {
                                    return h('span', type.label)
                                }
                            }
                        },
                        filters: [
                            {
                                label: '一体机终端',
                                value: 0
                            },
                            {
                                label: '人脸识别终端',
                                value: 2
                            },
                        ],
                        filterMultiple: false,
                        filterRemote(value, row) {
                            that.otherField = []
                            that.otherField.splice(0, 1, {value: value[0], field: row})
                            that.filterLoadData(value, row);
                        }
                    },
                    {
                        title: '异常终端',
                        key: 'from_terminal',
                        align: 'center',
                        width: 180
                    },
                    {
                        title: '发生时间',
                        key: 'insert_time',
                        align: 'center',
                        width: 180
                    },
                    {
                        type: 'expand',
                        title: '异常信息',
                        align: 'center',
                        key: 'error_info',
                        render: (h, params) => {
                            return h(expandRow, {
                                props: {
                                    title: '',
                                    row: {stacktrace: params.row.error_info}
                                }
                            });
                        }
                    },
                ],
                data: []
            };
        },
        methods: {
            loadData(page = 1, search = "") {
                this.loading = true;
                util.ajax.get('/exception/getterminalexlist', {
                    params: {
                        page: page,
                        size: this.page.size,
                        orderKey: this.page.sortKey,
                        orderMethod: this.page.sortMethod,
                        keyword: search
                    }
                }).then((res) => {
                    this.loading = false;
                    this.page.current = res.current;
                    this.page.total = res.total;
                    if (res.list) {
                        this.data = res.list.map(elem => {
                            if (elem.from_terminal.startsWith("T")) {
                                elem.identifier = 0
                            } else if (elem.from_terminal.startsWith("F")) {
                                elem.identifier = 2
                            }else if (elem.from_terminal.startsWith("L")) {
                                elem.identifier = 4
                            }
                            return elem;
                        });
                    }
                });
            },
            filterLoadData(val, row) {
                if (val.length) {
                    this.loadData(1, val[0])
                } else {
                    this.loadData(this.table.page.current)
                }
            },
            refreshPage: function () {
                this.loadData(page);
            },
            onDelete() { // 删除
                let ids = [];
                if (this.$refs.table.getSelection().length > 0) {
                    for (var row of this.$refs.table.getSelection()) {
                        ids = ids.concat(row.id);
                    }
                    util.ajax.get('/exception/terminaldelete?ids=' + ids).then((res) => {
                        this.loadData(1);
                    });
                } else {
                    this.$Message.warning('请选择要删除的记录');
                }
            },
            onEmpty() { // 清空
                util.ajax.post('/terminalexception/empty').then((res) => {
                    this.loadData(1);
                });
            },
        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style scoped>

</style>